import { useQuery } from '@tanstack/react-query';
import { notesService } from '../api/notes.service';
import { NOTE_KEYS } from './queryKeys';

/** Fetches the full content of one historical version — on-demand, when the user opens it for preview/restore. */
export function useNoteVersion(noteId: string | undefined, versionId: string | undefined) {
  return useQuery({
    queryKey: NOTE_KEYS.version(noteId ?? '', versionId ?? ''),
    queryFn: ({ signal }) => notesService.getVersion(noteId as string, versionId as string, signal),
    staleTime: Infinity,
    enabled: !!noteId && !!versionId,
  });
}
